export enum MilitaryRecord {
	Army = 'army',
	MarineCorp = 'marineCorp',
	Navy = 'navy',
	AirForce = 'airForce',
	SpaceForce = 'spaceForce',
	CoastGuard = 'coastGuard',
	NationalGuard = 'nationalGuard',
}
